import React from 'react';
import { useNavigate } from 'react-router';
import { AvatarWithFlag } from 'components/AvatarWithFlag';
import { Points } from 'components/Points/Points';
import { formatRelativeTime } from 'utils/relativeTime';
import { buildCardUrl } from 'utils/cardUrlUtils';
import type { FeedWant } from 'types/interfaces/feed';
import FeedCardImage from './FeedCardImage';

interface FeedNewWantsViewProps {
  wants: FeedWant[];
}

export const FeedNewWantsView: React.FC<FeedNewWantsViewProps> = ({ wants }) => {
  const navigate = useNavigate();

  const goToCard = (want: FeedWant) => (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(
      buildCardUrl({
        name: want.card.name,
        setCode: want.card.setCode,
        scryfallId: want.card.scryfallId,
      }),
    );
  };

  const goToProfile = (username: string) => (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/profile/u/${username}`);
  };

  return (
    <div className="feed-new-wants-view">
      {wants.map((want) => (
        <div key={want.id} className="feed-new-want-tile">
          <FeedCardImage
            scryfallId={want.card.scryfallId}
            name={want.card.name}
            onClick={goToCard(want)}
          />
          <div className="feed-new-want-tile__body">
            <button
              type="button"
              className="feed-new-want-tile__name"
              onClick={goToCard(want)}
            >
              {want.card.name}
            </button>
            <div className="feed-new-want-tile__meta">
              <span className="feed-new-want-tile__set">
                {(want.card.setCode || '').toUpperCase()}
              </span>
              <Points points={want.card.pointValue} type="small" />
            </div>
            <button
              type="button"
              className="feed-new-want-tile__user"
              onClick={goToProfile(want.user.username)}
            >
              <AvatarWithFlag
                size={24}
                avatarUrl={want.user.avatarUrl ?? undefined}
                username={want.user.username}
                countryCode={want.user.countryCode ?? undefined}
              />
              <span>Wanted by {want.user.username}</span>
            </button>
            <span
              className="feed-new-want-tile__timestamp"
              title={new Date(want.createdAt).toLocaleString()}
            >
              {formatRelativeTime(want.createdAt)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeedNewWantsView;
